import {createWithEqualityFn} from 'zustand/traditional';
import {shallow} from 'zustand/shallow';

import {devtools} from 'utils/zustand';
import {WhatsNewPeriod} from 'modules/decisionsNext/sections/WhatsNewSection/constants';

export const initialFilter: WhatsNewPageFiltersStore = {
  filter: {
    period: WhatsNewPeriod.All,
    categories: [],
    types: [],
  },
  newFeaturesCount: 0,
  hasAlreadySeenWhatsNewPage: true,
};

export type WhatsNewPageFiltersStore = {
  filter: {
    period: WhatsNewPeriod;
    categories: string[];
    types: string[];
  };
  newFeaturesCount: number;
  hasAlreadySeenWhatsNewPage: boolean;
};

export const useWhatsNewFiltersStore = createWithEqualityFn<WhatsNewPageFiltersStore>()(
  devtools<WhatsNewPageFiltersStore>(() => initialFilter, {
    name: 'WhatsNewFiltersStore',
    store: 'WHATS_NEW_FILTERS_STORE',
  }),
  shallow
);

export const setWhatsNewStore = (store: WhatsNewPageFiltersStore) => {
  useWhatsNewFiltersStore.setState(() => store, false, 'setWhatsNewStore');
};

export const setWhatsNewPeriod = (period: WhatsNewPeriod) => {
  useWhatsNewFiltersStore.setState(
    state => ({
      filter: {
        ...state.filter,
        period,
      },
    }),
    false,
    'setWhatsNewPeriod'
  );
};

export const setWhatsNewCategories = (newCategories: string[]) => {
  useWhatsNewFiltersStore.setState(
    state => ({
      filter: {
        ...state.filter,
        categories: newCategories,
      },
    }),
    false,
    'setWhatsNewCategories'
  );
};

export const setWhatsNewFeatureTypes = (newTypes: string[]) => {
  useWhatsNewFiltersStore.setState(
    state => ({
      filter: {
        ...state.filter,
        types: newTypes,
      },
    }),
    false,
    'setWhatsNewFeatureTypes'
  );
};

export const resetWhatsNewFilter = () => {
  useWhatsNewFiltersStore.setState(
    state => ({...state, filter: {...initialFilter.filter}}),
    false,
    'resetWhatsNewFilter'
  );
};

export const setNewFeaturesCount = (newFeaturesCount: number) => {
  useWhatsNewFiltersStore.setState(
    state => ({
      ...state,
      newFeaturesCount,
    }),
    false,
    'setNewFeaturesCount'
  );
};

export const setHasAlreadySeenWhatsNewPage = (hasAlreadySeenWhatsNewPage: boolean) => {
  useWhatsNewFiltersStore.setState(
    state => ({
      ...state,
      hasAlreadySeenWhatsNewPage,
    }),
    false,
    'setHasAlreadySeenWhatsNewPage'
  );
};
